import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CustomCheckboxComponent } from '../../../components/custom-checkbox/custom-checkbox.component';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-accept-tos-dialog',
  templateUrl: './accept-tos-dialog.component.html',
  styleUrls: ['./accept-tos-dialog.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CustomCheckboxComponent,
    MatButton,
    MatDialogClose,
    TranslateModule,
  ],
})
export class AcceptTosDialogComponent {
  private fb = inject(FormBuilder);

  readonly formGroup = this.fb.group({
    aszf: this.fb.control(false, {
      validators: Validators.requiredTrue,
      nonNullable: true,
    }),
    pp: this.fb.control(false, {
      validators: Validators.requiredTrue,
      nonNullable: true,
    }),
  });

  get aszf() {
    return this.formGroup.controls.aszf;
  }
  get pp() {
    return this.formGroup.controls.pp;
  }

  async onClose() {
    if (this.formGroup.invalid) {
      return;
    }
  }
}
